import { render, staticRenderFns } from "./customer-order-data.vue?vue&type=template&id=55dbe26f&scoped=true"
import script from "./customer-order-data.vue?vue&type=script&lang=ts"
export * from "./customer-order-data.vue?vue&type=script&lang=ts"
import style0 from "./customer-order-data.vue?vue&type=style&index=0&id=55dbe26f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dbe26f",
  null
  
)

export default component.exports